export default "__VITE_ASSET__qqaZ1omn__"